import script from "./FooterBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterBar.vue?vue&type=script&lang=ts&setup=true"

import "./FooterBar.vue?vue&type=style&index=0&id=16880792&lang=scss"

const __exports__ = script;

export default __exports__